(() => {
  const root = document.querySelector('.asmpd-shell[data-search-index]');
  const form = root?.querySelector('.asmpd__search-form');
  const input = root?.querySelector('#asmpd-query');
  const status = root?.querySelector('.asmpd__search-status');
  const results = root?.querySelector('.asmpd__results');
  if (!root || !form || !input || !status || !results) return;
  let recordsPromise;
  let generation = 0;
  const queryKey = `asmpd-submitted-query:${location.pathname}`;
  const remember = value => { try { if (value) sessionStorage.setItem(queryKey, value.slice(0, 512)); else sessionStorage.removeItem(queryKey); } catch (_) {} };
  const remembered = () => { try { return sessionStorage.getItem(queryKey) || ''; } catch (_) { return ''; } };
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const load = () => recordsPromise ||= fetch(root.dataset.searchIndex, {credentials: 'same-origin'}).then(response => {
    if (!response.ok) throw new Error(`Search index ${response.status}`);
    return response.json();
  }).then(payload => payload.records).catch(error => { recordsPromise = undefined; throw error; });
  const clear = () => { results.replaceChildren(); };
  const run = async event => {
    event?.preventDefault();
    const currentGeneration = ++generation;
    remember(input.value.trim());
    const query = normalize(input.value);
    clear();
    if (query.length < 2) { status.textContent = 'Enter at least two characters.'; return; }
    status.textContent = 'Searching the published catalog…';
    try {
      const records = await load();
      if (currentGeneration !== generation) return;
      const terms = query.split(' ');
      const matches = records.filter(record => terms.every(term => record.x.includes(term)));
      const shown = matches.slice(0, 24);
      for (const record of shown) {
        const item = document.createElement('li'); item.className = 'asmpd__person';
        const link = document.createElement('a'); link.href = `/pages/${record.h}`; link.textContent = `${record.n} missing-person guide`;
        const date = document.createElement('span'); date.textContent = record.d;
        const location = document.createElement('span'); location.textContent = record.l ? `Source-listed location: ${record.l}` : '';
        const source = document.createElement('span'); source.textContent = `${record.s} · source checked ${record.c}`;
        item.append(link, date); if (record.l) item.append(location); item.append(source); results.append(item);
      }
      status.textContent = matches.length
        ? `Found ${matches.length.toLocaleString()} match${matches.length === 1 ? '' : 'es'}. Showing ${shown.length}.${matches.length > shown.length ? ' Add a name, location, or date to narrow the results, or browse A–Z.' : ''}`
        : 'No matches in the current published catalog. Try another spelling or browse by letter.';
    } catch (_) { if (currentGeneration !== generation) return; status.textContent = 'Search is temporarily unavailable. Use the A–Z links to browse every published guide.'; }
  };
  form.addEventListener('submit', run);
  input.addEventListener('input', () => {
    if (!input.value.trim()) { generation += 1; remember(''); clear(); status.textContent = ''; }
  });
  const restore = () => {
    const query = input.value.trim() || remembered();
    if (query.length >= 2) { input.value = query; run(); }
  };
  window.addEventListener('pageshow', restore);
  restore();
})();
